import { ForegroundColor } from 'chalk';
import { Box, Text } from 'ink';

export default function ProgressBar({
  color = 'white',
  label,
  labelWidth = 9,
  marginBottom = 1,
  progress,
  text = '',
}: {
  color?: typeof ForegroundColor;
  label: string;
  labelWidth?: number;
  marginBottom?: number;
  progress?: number;
  text?: string | null;
}) {
  const percentage =
    progress && progress > 0
      ? Math.round(progress).toString().padStart(2, '0') + '%'
      : '';

  const displayedText = (text || '')
    .replace(/(?:\r\n|\r|\n)\s*/g, '↵ ')
    .replace(/(.{63}).+/, '$1…');

  return (
    <Box marginBottom={marginBottom}>
      <Box width={labelWidth}>
        <Text>{label}:</Text>
      </Box>
      <Box width={6} justifyContent="flex-end" marginRight={1}>
        {Boolean(percentage) && (
          <Text backgroundColor={color} color="black">
            {` ${percentage} `}
          </Text>
        )}
      </Box>
      <Box>
        <Text>{displayedText}</Text>
      </Box>
    </Box>
  );
}
